import React, { useEffect, useCallback, useState} from 'react';
import Dropdown from 'react-dropdown';
import InletField from "components/zobject/InletField.js";
import ZNumber from "components/zobject/ZNumber.js";
import {is3DType, RECT, BOX, CIRCLE, SPHERE} from "zobject/custom/sdf/types.js";
import {connect} from 'react-redux';
import {sdf_types} from 'zobject/definitions/gl/sdf/sdf-types.js';
import './sdf.scss';

const OPTIONS = Object.keys(sdf_types).map(type => ({
    value: type, label: type[0].toUpperCase() + type.slice(1)
}));

const ZSDFBuilder = ({_type, builder}) => { 
    let [type, setType] = useState(builder.type);

    useEffect(() => {
        if (_type) {
            setType(_type);
        }
    }, [_type, setType]);

    const onChange = useCallback(() => {
        builder.sendObject();
    }, [builder]);

    const onChangeType = useCallback((e) =>
        {
            setType(e.value);
            builder.type = e.value;
            builder.sendObject();
        },
        setType, builder);

    let is3D = is3DType(type);

    if (!builder.x) {
        return '';
    }
    return (
        <div className="sdf-builder">
          <Dropdown value={type} onChange={onChangeType} options={OPTIONS}/>
          <SDFField builder={builder} onChange={onChange} name="x" get={builder.x}/>
          <SDFField builder={builder} onChange={onChange} name="y" get={builder.y}/>
          {is3D && <SDFField builder={builder} onChange={onChange} name="z" get={builder.z}/>}
          <SDFField builder={builder} onChange={onChange} name="width" get={builder.w}/>
          <SDFField builder={builder} onChange={onChange} name="height" get={builder.h}/>
          {is3D && <SDFField builder={builder} onChange={onChange} name="depth" get={builder.d}/>}
          <SDFField builder={builder} onChange={onChange} name="corner" get={builder.c}/>
          {!is3D && <SDFField builder={builder} onChange={onChange} name="rotation" get={builder.r}/>}
          {is3D && <SDFField builder={builder} onChange={onChange} name="repeat x" get={builder.repeatCountX}/>}
          {is3D && <SDFField builder={builder} onChange={onChange} name="repeat y" get={builder.repeatCountY}/>}
          {is3D && <SDFField builder={builder} onChange={onChange} name="repeat z" get={builder.repeatCountZ}/>}
          {is3D && <SDFField builder={builder} onChange={onChange} name="repeat spread" get={builder.repeatSpread}/>}
        </div>);
}

export const SDFField = ({name, onChange, get, builder}) => {
    return (
        <InletField object={builder} inlet={name}>
          <div className="sdf-field">
            <div className="field-name">{name}</div>
            <ZNumber onChange={onChange} znumber={get}/>
          </div>
        </InletField>
    );
};

const mapStateToProps = (state, props) => {
  return {
      xComponent: props.builder.x,
      _type: props.builder.type,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZSDFBuilder);
